define('core/utils/html/nodeTypes',[],function () {
    'use strict';

    var isP = function (node) {
        return node.nodeName.toLowerCase() === 'p';
    };

    var isDiv = function (node) {
        return node.nodeName.toLowerCase() === 'div';
    };

    var isText = function (node) {
        return node.nodeName.toLowerCase() === '#text';
    };

    var isBr = function (node) {
        return node.nodeName.toLowerCase() === 'br';
    };

    var isNewline = function (node) {
        return node.nodeName.toLowerCase() === 'br' || (node.nodeName.toLowerCase() === '#text' && node.nodeValue === '\n');
    };

    var isPorDiv = function (node) {
        return node.nodeName.toLowerCase() === 'p' || node.nodeName.toLowerCase() === 'div';
    };

    return {
        isP: isP,
        isDiv: isDiv,
        isText: isText,
        isBr: isBr,
        isNewline: isNewline,
        isPorDiv: isPorDiv,
    };
});

